export default {
  data () {
    return {
      // Live c3d68cda-85f3-44c1-b578-6609e86e305e
      // Demo a13ea432-fae7-479c-93ec-3a5799034c7c
      live_id: 'c3d68cda-85f3-44c1-b578-6609e86e305e', // OBTS LIVE USD
      // kes_test_id: 'fc422543-434d-4572-9270-409b17be2014',
      kes_live_id: ' a98a2520-77f0-4ff9-a0a5-29ee81852fef', //OBTS LIVE KES
      // live_id: 'a13ea432-fae7-479c-93ec-3a5799034c7c',
      // Test
      // iveri_url: 'http://165.227.117.249'
      // Production
      // https://167.99.85.35

      // iveri_url: 'http://165.227.117.249'
      iveri_url: 'https://bookings.olpejetaconservancy.org/',
      // iveri_catcher_url: 'https://167.99.85.35:8001/'
      iveri_catcher_url: "https://bookings.olpejetaconservancy.org:5019/"
    }
  },
  computed: {
    bookingStatus: function () {
      var name = this.$route.name.split('.', 1)
      if (name[0] === 'Booking') {
        this.booking = true
      } else {
        this.booking = false
      }
    },
    $currentUrl () {
      return this.$route.name
    }
  },
  methods: {
    numberLimiter (min, currentNumber, max) {
      if (currentNumber <= min && currentNumber >= max) {
        return currentNumber
      } else {
        alert('That input is beyond the Maximum')
      }
    }
  }
}
